import { render, staticRenderFns } from "./TransportModeBlock.vue?vue&type=template&id=00ed9fe3"
import script from "./TransportModeBlock.vue?vue&type=script&lang=ts"
export * from "./TransportModeBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports